import { HttpErrorResponse } from '@angular/common/http';

/**
 * The session was rejected by the server — the user genuinely needs to sign in
 * again. Anything else (offline, DNS, timeout, 5xx) means we simply could not
 * ask, and must not be mistaken for a failed login.
 */
export const isAuthError = (error: unknown): boolean => {
  const status = (error as HttpErrorResponse)?.status;
  return status === 401 || status === 403;
};

/**
 * Worth another attempt: status 0 covers offline, DNS failure, connection reset
 * and the timeouts synthesised by TimeoutInterceptor — all of which are routine
 * on a phone that just woke up or switched between WiFi and mobile data.
 */
export const isRetriableHttpError = (error: unknown): boolean => {
  const status = (error as HttpErrorResponse)?.status;
  return status === 0 || status === 408 || status === 429 || (status >= 500 && status <= 599);
};
